export enum RevalidationStatus {
  NotSubmitted = 0,
  WithinWindow = 1,
  Remediation = 2,
  NIR = 3,
  NOR = 4,
  NoRIssued = 5
}
